var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900",attrs:{"href":"#","role":"menuitem"},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t(_vm.title)))])
}
var staticRenderFns = []

export { render, staticRenderFns }